function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 6.03125,
  y: 2.03467,
  width: 19.9375,
  height: 27.9219,
  rx: 2.6,
  fill: "url(#paint0_linear_18_19048)"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 6.03125,
  y: 2.03467,
  width: 19.9375,
  height: 27.9219,
  rx: 2.6,
  fill: "url(#paint1_linear_18_19048)"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ii_18_19048)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.20312 9.07998C9.20312 8.74861 9.47175 8.47998 9.80313 8.47998H11.9156C12.247 8.47998 12.5156 8.74861 12.5156 9.07998V11.1925C12.5156 11.5239 12.247 11.7925 11.9156 11.7925H9.80312C9.47175 11.7925 9.20312 11.5239 9.20312 11.1925V9.07998Z",
  fill: "#FF9544"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.20312 9.07998C9.20312 8.74861 9.47175 8.47998 9.80313 8.47998H11.9156C12.247 8.47998 12.5156 8.74861 12.5156 9.07998V11.1925C12.5156 11.5239 12.247 11.7925 11.9156 11.7925H9.80312C9.47175 11.7925 9.20312 11.5239 9.20312 11.1925V9.07998Z",
  fill: "url(#paint2_linear_18_19048)"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_ii_18_19048)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.3438 9.07998C14.3438 8.74861 14.6124 8.47998 14.9438 8.47998H17.0563C17.3876 8.47998 17.6562 8.74861 17.6562 9.07998V11.1925C17.6562 11.5239 17.3876 11.7925 17.0563 11.7925H14.9437C14.6124 11.7925 14.3438 11.5239 14.3438 11.1925V9.07998Z",
  fill: "#38C6FF"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_ii_18_19048)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.4844 9.07998C19.4844 8.74861 19.753 8.47998 20.0844 8.47998H22.1969C22.5282 8.47998 22.7969 8.74861 22.7969 9.07998V11.1925C22.7969 11.5239 22.5282 11.7925 22.1969 11.7925H20.0844C19.753 11.7925 19.4844 11.5239 19.4844 11.1925V9.07998Z",
  fill: "#FFEC58"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_ii_18_19048)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.20312 14.9394C9.20312 14.608 9.47175 14.3394 9.80313 14.3394H11.9156C12.247 14.3394 12.5156 14.608 12.5156 14.9394V17.0519C12.5156 17.3832 12.247 17.6519 11.9156 17.6519H9.80312C9.47175 17.6519 9.20312 17.3832 9.20312 17.0519V14.9394Z",
  fill: "#38C6FF"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_ii_18_19048)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.20312 20.7987C9.20312 20.4674 9.47175 20.1987 9.80313 20.1987H11.9156C12.247 20.1987 12.5156 20.4674 12.5156 20.7987V22.9112C12.5156 23.2426 12.247 23.5112 11.9156 23.5112H9.80312C9.47175 23.5112 9.20312 23.2426 9.20312 22.9112V20.7987Z",
  fill: "#FF9544"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.20312 20.7987C9.20312 20.4674 9.47175 20.1987 9.80313 20.1987H11.9156C12.247 20.1987 12.5156 20.4674 12.5156 20.7987V22.9112C12.5156 23.2426 12.247 23.5112 11.9156 23.5112H9.80312C9.47175 23.5112 9.20312 23.2426 9.20312 22.9112V20.7987Z",
  fill: "url(#paint3_linear_18_19048)"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_ii_18_19048)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.3438 14.9394C14.3438 14.608 14.6124 14.3394 14.9438 14.3394H17.0563C17.3876 14.3394 17.6562 14.608 17.6562 14.9394V17.0519C17.6562 17.3832 17.3876 17.6519 17.0563 17.6519H14.9437C14.6124 17.6519 14.3438 17.3832 14.3438 17.0519V14.9394Z",
  fill: "#FFEC58"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_ii_18_19048)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.3438 20.7987C14.3438 20.4674 14.6124 20.1987 14.9438 20.1987H17.0563C17.3876 20.1987 17.6562 20.4674 17.6562 20.7987V22.9112C17.6562 23.2426 17.3876 23.5112 17.0563 23.5112H14.9437C14.6124 23.5112 14.3438 23.2426 14.3438 22.9112V20.7987Z",
  fill: "#38C6FF"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter7_ii_18_19048)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.4844 14.9394C19.4844 14.608 19.753 14.3394 20.0844 14.3394H22.1969C22.5282 14.3394 22.7969 14.608 22.7969 14.9394V17.0519C22.7969 17.3832 22.5282 17.6519 22.1969 17.6519H20.0844C19.753 17.6519 19.4844 17.3832 19.4844 17.0519V14.9394Z",
  fill: "#FF9544"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.4844 14.9394C19.4844 14.608 19.753 14.3394 20.0844 14.3394H22.1969C22.5282 14.3394 22.7969 14.608 22.7969 14.9394V17.0519C22.7969 17.3832 22.5282 17.6519 22.1969 17.6519H20.0844C19.753 17.6519 19.4844 17.3832 19.4844 17.0519V14.9394Z",
  fill: "url(#paint4_linear_18_19048)"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter8_ii_18_19048)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.4844 20.7987C19.4844 20.4674 19.753 20.1987 20.0844 20.1987H22.1969C22.5282 20.1987 22.7969 20.4674 22.7969 20.7987V22.9112C22.7969 23.2426 22.5282 23.5112 22.1969 23.5112H20.0844C19.753 23.5112 19.4844 23.2426 19.4844 22.9112V20.7987Z",
  fill: "#FFEC58"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter9_f_18_19048)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 23.6875,
  y: 5.59717,
  width: 1.53125,
  height: 21.8438,
  fill: "url(#paint5_linear_18_19048)"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter10_i_18_19048)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.9688 6.15967H6.03125V4.63467C6.03125 3.19873 7.19531 2.03467 8.63125 2.03467H23.3688C24.8047 2.03467 25.9688 3.19873 25.9688 4.63467V6.15967Z",
  fill: "url(#paint6_linear_18_19048)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.9688 6.15967H6.03125V4.63467C6.03125 3.19873 7.19531 2.03467 8.63125 2.03467H23.3688C24.8047 2.03467 25.9688 3.19873 25.9688 4.63467V6.15967Z",
  fill: "url(#paint7_linear_18_19048)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.9688 6.15967H6.03125V4.63467C6.03125 3.19873 7.19531 2.03467 8.63125 2.03467H23.3688C24.8047 2.03467 25.9688 3.19873 25.9688 4.63467V6.15967Z",
  fill: "url(#paint8_linear_18_19048)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.9688 6.15967H6.03125V4.63467C6.03125 3.19873 7.19531 2.03467 8.63125 2.03467H23.3688C24.8047 2.03467 25.9688 3.19873 25.9688 4.63467V6.15967Z",
  fill: "url(#paint9_linear_18_19048)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.9688 6.15967H6.03125V4.63467C6.03125 3.19873 7.19531 2.03467 8.63125 2.03467H23.3688C24.8047 2.03467 25.9688 3.19873 25.9688 4.63467V6.15967Z",
  fill: "url(#paint10_radial_18_19048)"
}));

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9688 25.8784V27.3565C25.9688 28.7925 24.8047 29.9565 23.3688 29.9565H8.63125C7.19531 29.9565 6.03125 28.7925 6.03125 27.3565V25.8784H25.9688Z",
  fill: "url(#paint11_linear_18_19048)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9688 25.8784V27.3565C25.9688 28.7925 24.8047 29.9565 23.3688 29.9565H8.63125C7.19531 29.9565 6.03125 28.7925 6.03125 27.3565V25.8784H25.9688Z",
  fill: "url(#paint12_linear_18_19048)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9688 25.8784V27.3565C25.9688 28.7925 24.8047 29.9565 23.3688 29.9565H8.63125C7.19531 29.9565 6.03125 28.7925 6.03125 27.3565V25.8784H25.9688Z",
  fill: "url(#paint13_radial_18_19048)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9688 25.8784V27.3565C25.9688 28.7925 24.8047 29.9565 23.3688 29.9565H8.63125C7.19531 29.9565 6.03125 28.7925 6.03125 27.3565V25.8784H25.9688Z",
  fill: "url(#paint14_linear_18_19048)"
});

var _ref19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ii_18_19048",
  x: 8.90312,
  y: 8.17998,
  width: 3.9125,
  height: 3.9125,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.3,
  dy: -0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.913725 0 0 0 0 0.384314 0 0 0 0 0.129412 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_19048"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.3,
  dy: 0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.498039 0 0 0 0 0.160784 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_19048",
  result: "effect2_innerShadow_18_19048"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_ii_18_19048",
  x: 14.0437,
  y: 8.17998,
  width: 3.9125,
  height: 3.9125,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.3,
  dy: -0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0980392 0 0 0 0 0.572549 0 0 0 0 0.866667 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_19048"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.3,
  dy: 0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0745098 0 0 0 0 0.709804 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_19048",
  result: "effect2_innerShadow_18_19048"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_ii_18_19048",
  x: 19.1844,
  y: 8.17998,
  width: 3.9125,
  height: 3.9125,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.3,
  dy: -0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.858824 0 0 0 0 0.752941 0 0 0 0 0.188235 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_19048"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.3,
  dy: 0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.968627 0 0 0 0 0.858824 0 0 0 0 0.223529 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_19048",
  result: "effect2_innerShadow_18_19048"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_ii_18_19048",
  x: 8.90312,
  y: 14.0394,
  width: 3.9125,
  height: 3.9125,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.3,
  dy: -0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0980392 0 0 0 0 0.572549 0 0 0 0 0.866667 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_19048"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.3,
  dy: 0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0745098 0 0 0 0 0.709804 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_19048",
  result: "effect2_innerShadow_18_19048"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_ii_18_19048",
  x: 8.90312,
  y: 19.8987,
  width: 3.9125,
  height: 3.9125,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.3,
  dy: -0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.913725 0 0 0 0 0.384314 0 0 0 0 0.129412 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_19048"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.3,
  dy: 0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.498039 0 0 0 0 0.160784 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_19048",
  result: "effect2_innerShadow_18_19048"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_ii_18_19048",
  x: 14.0437,
  y: 14.0394,
  width: 3.9125,
  height: 3.9125,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.3,
  dy: -0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.858824 0 0 0 0 0.752941 0 0 0 0 0.188235 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_19048"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.3,
  dy: 0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.968627 0 0 0 0 0.858824 0 0 0 0 0.223529 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_19048",
  result: "effect2_innerShadow_18_19048"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_ii_18_19048",
  x: 14.0437,
  y: 19.8987,
  width: 3.9125,
  height: 3.9125,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.3,
  dy: -0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0980392 0 0 0 0 0.572549 0 0 0 0 0.866667 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_19048"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.3,
  dy: 0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0745098 0 0 0 0 0.709804 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_19048",
  result: "effect2_innerShadow_18_19048"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7_ii_18_19048",
  x: 19.1844,
  y: 14.0394,
  width: 3.9125,
  height: 3.9125,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.3,
  dy: -0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.913725 0 0 0 0 0.384314 0 0 0 0 0.129412 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_19048"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.3,
  dy: 0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.498039 0 0 0 0 0.160784 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_19048",
  result: "effect2_innerShadow_18_19048"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter8_ii_18_19048",
  x: 19.1844,
  y: 19.8987,
  width: 3.9125,
  height: 3.9125,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.3,
  dy: -0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.858824 0 0 0 0 0.752941 0 0 0 0 0.188235 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_19048"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.3,
  dy: 0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.968627 0 0 0 0 0.858824 0 0 0 0 0.223529 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_19048",
  result: "effect2_innerShadow_18_19048"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter9_f_18_19048",
  x: 22.6875,
  y: 4.59717,
  width: 3.53125,
  height: 23.8438,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_18_19048"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter10_i_18_19048",
  x: 6.03125,
  y: 2.03467,
  width: 19.9375,
  height: 4.225,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.375
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.380392 0 0 0 0 0.407843 0 0 0 0 0.666667 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_19048"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_18_19048",
  x1: 16,
  y1: 7.44092,
  x2: 16,
  y2: 26.0034,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#62326D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#434486"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_18_19048",
  x1: 6.03125,
  y1: 21.8159,
  x2: 8.34375,
  y2: 21.8784,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.03125,
  stopColor: "#412C4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#412C4C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_18_19048",
  x1: 9.35937,
  y1: 10.9565,
  x2: 10.4062,
  y2: 10.9565,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.333333,
  stopColor: "#FF945C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF945C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_18_19048",
  x1: 9.35937,
  y1: 22.6753,
  x2: 10.4062,
  y2: 22.6753,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.333333,
  stopColor: "#FF945C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF945C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_18_19048",
  x1: 19.6406,
  y1: 16.8159,
  x2: 20.6875,
  y2: 16.8159,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.333333,
  stopColor: "#FF945C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF945C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_18_19048",
  x1: 24.4531,
  y1: 5.59717,
  x2: 24.4531,
  y2: 27.4409,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#674876"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#555187"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_18_19048",
  x1: 16,
  y1: 2.03467,
  x2: 16,
  y2: 6.15967,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#636AB6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6C6EBE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_18_19048",
  x1: 17.1563,
  y1: 6.31592,
  x2: 17.1563,
  y2: 5.62842,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6062B1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6062B1",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_18_19048",
  x1: 6.03125,
  y1: 6.15967,
  x2: 9.25,
  y2: 6.15967,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.135922,
  stopColor: "#484B86"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5E61AD",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_18_19048",
  x1: 25.9688,
  y1: 6.15967,
  x2: 23.0312,
  y2: 6.15967,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.12766,
  stopColor: "#7277C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7277C8",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint10_radial_18_19048",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.9688 5.87842) rotate(-180) scale(0.65625 3.17187)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6C6FB4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6C6FB4",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_18_19048",
  x1: 16,
  y1: 25.8784,
  x2: 16,
  y2: 29.9565,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6B4390"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#76509E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_18_19048",
  x1: 6.03125,
  y1: 27.1284,
  x2: 8.4375,
  y2: 27.1284,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.164179,
  stopColor: "#4F3D6C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6E4693",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint13_radial_18_19048",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(24.3125 25.5347) rotate(90) scale(3.09375 1.625)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6B5094"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6B5094",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_18_19048",
  x1: 15.6875,
  y1: 25.5972,
  x2: 15.6875,
  y2: 26.1909,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.157895,
  stopColor: "#5E3D7F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5E3D7F",
  stopOpacity: 0
})));

function SvgMobilePhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePhone);
export default __webpack_public_path__ + "static/media/mobile-phone.281e6ad9.svg";
export { ForwardRef as ReactComponent };